var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeroBackground = function SvgHeroBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 4532"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 3701H0v603.24L718.438 4532 1440 4303.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 3125H0v603.24L718.438 3956 1440 3727.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 2544H0v603.24L718.438 3375 1440 3146.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 1968H0v603.24L718.438 2799 1440 2570.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 1572H0v603.24L718.438 2403 1440 2174.25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 996H0v603.24L718.438 1827 1440 1598.25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 576H0v603.24L718.438 1407 1440 1178.25z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M1440 0H0v603.236L718.438 831 1440 602.247z"
  })));
};
export default SvgHeroBackground;